export const validate = formData => {
  let error = {};

  ['password', 'confirmPassword'].forEach(itm => {
    switch (itm) {
      case 'password':
        let passwordErrors = [];
        if (!formData.password) {
          passwordErrors.push('Password is required');
        } else {
          if (formData.password.length < 8) {
            passwordErrors.push('Must be at least 8 characters');
          }
          if (!/[A-Z]/.test(formData.password)) {
            passwordErrors.push('Must contain at least one uppercase letter');
          }
          if (!/[0-9]/.test(formData.password)) {
            passwordErrors.push('Must contain at least one number');
          }
          if (!/[!@#$%^&*(),.?\":{}|<>]/.test(formData.password)) {
            passwordErrors.push('Must contain at least one special character');
          }
        }
        if (passwordErrors.length > 0) {
          error.password = passwordErrors;
        }
        break;

      case 'confirmPassword':
        if (!formData.confirmPassword) {
          error.confirmPassword = 'Confirm Password is required';
        } else if (formData.password !== formData.confirmPassword) {
          error.confirmPassword = 'Passwords do not match';
        }
        break;

      default:
        break;
    }
  });

  return error;
};
